<template>
    <div class="brand-container">
        <!-- Banner -->
        <CommonComponentsSolutionsBrandSwipper />
        <div class="global-limited-1360px-container">
            <CommonComponentsSolutionsBrandTitleimage />

            <!-- 1 -->
            <CommonComponentsSolutionsBrandArrows />
        </div>
        <!-- 2 -->
        <CommonComponentsSolutionsBrandPanoramagram />
    </div>
</template>

<script setup lang="ts">
    import { ifCNLocale } from '~~/composables/useLocale.ts';

    const isCN = ifCNLocale();
    onMounted(() => {
        document.lazyLoadInstance.update();
    });
</script>

<style lang="less" scoped>
    .brand-container {
        background-color: #000000;
        width: 100%;
        color: #fff;
        overflow: hidden;

        :deep(.union-title-container .union-title) {
            font-size: .convert(@font-size-title) [ @vw]; //48px
        }
    }
</style>
